// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .post-modal {
    width: min(920px, 94vw);
    max-height: 92vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background: rgba(255, 255, 255, .96);
    backdrop-filter: blur(18px);
    border-radius: 28px;
    box-shadow:
        0 30px 80px rgba(0, 0, 0, .22),
        inset 0 1px 0 rgba(255, 255, 255, .7);
    animation: postModalIn .28s ease;
    position: relative;
} */


.post-modal {
    width: min(1400px, 96vw);
    height: min(90vh, 950px);

    overflow: hidden;

    display: flex;
    flex-direction: row;

    background: white;
    border-radius: 28px;

    box-shadow:
        0 30px 80px rgba(0, 0, 0, .22);

    animation: postModalIn .28s ease;
    position: relative;
}

/* header */
.post-modal-header {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 22px 24px;
    border-bottom: 1px solid rgba(0, 0, 0, .06);
    background: linear-gradient(to bottom,
            rgba(255, 255, 255, .92),
            rgba(255, 255, 255, .75));
    backdrop-filter: blur(14px);
}

.post-modal-header img {
    width: 52px;
    height: 52px;
    border-radius: 50%;
    object-fit: cover;
    border: 3px solid white;
    box-shadow: 0 8px 24px rgba(0, 0, 0, .12);
}

.post-modal-header strong {
    font-size: 17px;
    font-weight: 800;
    color: #111827;
    letter-spacing: -.2px;
}

/* text */
.post-modal-text {
    margin: 0;
    padding: 22px 24px 8px;
    font-size: 15px;
    line-height: 1.7;
    color: #1f2937;
    white-space: pre-wrap;
    word-break: break-word;
}

/* media wrapper */
.post-modal-media {
    width: calc(100% - 32px);
    margin: 16px;
    max-height: 68vh;
    object-fit: contain;
    border-radius: 24px;
    background:
        linear-gradient(135deg,
            #0f172a,
            #111827);
    box-shadow:
        0 18px 50px rgba(0, 0, 0, .18);
    display: block;
}

/* video */
video.post-modal-media {
    outline: none;
}

/* scrollbar */
.post-modal::-webkit-scrollbar {
    width: 8px;
}

.post-modal::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, .15);
    border-radius: 50px;
}

/* animation */
@keyframes postModalIn {
    from {
        opacity: 0;
        transform: translateY(24px) scale(.96);
    }

    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

/* mobile */
@media (max-width: 768px) {
    .post-modal {
        width: 100vw;
        height: 100vh;
        max-height: 100vh;
        border-radius: 0;
    }

    .post-modal-header {
        padding: 18px;
    }

    .post-modal-text {
        padding: 18px 18px 6px;
        font-size: 14px;
    }

    .post-modal-media {
        width: calc(100% - 18px);
        margin: 9px;
        border-radius: 18px;
        max-height: 56vh;
    }
}


.post-modal-close {
    width: 42px;
    height: 42px;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f3f5f8;
    color: #111;
    flex-shrink: 0;
    transition: .2s;
}

.post-modal-close:hover {
    transform: scale(1.05);
    background: #e9edf4;
}

.post-modal-close.mobile {
    display: none;
}

.post-modal-close.desktop {
    margin-left: auto;
}

@media (max-width:768px) {
    .post-modal-close.mobile {
        display: flex;
    }

    .post-modal-close.desktop {
        display: none;
    }
}


.post-modal-skeleton {
    padding: 24px;
}

.pm-sk-header {
    display: flex;
    align-items: center;
    gap: 14px;
    margin-bottom: 24px;
}

.pm-sk-avatar {
    width: 52px;
    height: 52px;
    border-radius: 50%;
}

.pm-sk-name {
    width: 140px;
    height: 18px;
    border-radius: 20px;
}

.pm-sk-text {
    width: 100%;
    height: 14px;
    border-radius: 20px;
    margin-bottom: 12px;
}

.pm-sk-text.short {
    width: 55%;
}

.pm-sk-media {
    width: 100%;
    height: 420px;
    border-radius: 24px;
    margin-top: 20px;
}

.skeleton {
    background: linear-gradient(90deg,
            #ececec,
            #f7f7f7,
            #ececec);
    background-size: 200% 100%;
    animation: pulse 1.2s infinite;
}

@keyframes pulse {
    0% {
        background-position: 200% 0;
    }

    100% {
        background-position: -200% 0;
    }
}


.instagram-post-layout {
    display: flex;
    width: 100%;
    height: 100%;
    background: white;
    border-radius: 24px;
    overflow: hidden;

}

.instagram-left {
    width: 60%;
    background: black;
    display: flex;
    align-items: center;
    justify-content: center;
}

.instagram-main-media {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.instagram-right {
    width: 40%;
    display: flex;
    flex-direction: column;
    border-left: 1px solid #eee;
    background: white;
}

.instagram-post-header {
    height: 72px;
    padding: 20px;
    display: flex;
    align-items: center;
    gap: 12px;
    border-bottom: 1px solid #eee;
}

.instagram-post-header img {
    width: 42px;
    height: 42px;
    border-radius: 50%;
    object-fit: cover;
}


.instagram-right .comment-panel {
    background: white !important;

    width: 100% !important;
    height: 100% !important;

    min-height: 0 !important;
    max-height: none !important;

    border-radius: 0 !important;

    display: flex !important;
    flex-direction: column !important;

    animation: none !important;

    overflow: hidden !important;
}

.instagram-right .comment-list {
    flex: 1 1;
    overflow-y: auto;
    min-height: 0;
}

.instagram-right .comment-input {
    margin-top: auto;
    border-top: 1px solid #eee;
    background: white;
}

.instagram-post-layout .comment-overlay {
    position: relative !important;

    width: 40% !important;
    height: 100% !important;

    top: auto !important;
    left: auto !important;
    right: auto !important;
    bottom: auto !important;

    transform: none !important;

    background: white !important;

    display: flex !important;
    flex-direction: column !important;

    overflow: hidden !important;
}

.instagram-post-layout .comment-panel {
    width: 100% !important;
    height: 100% !important;
    max-height: none !important;

    border-radius: 0 !important;
    animation: none !important;

    display: flex !important;
    flex-direction: column !important;
}

.instagram-post-layout .comment-list {
    flex: 1 1 !important;
    overflow-y: auto !important;
    min-height: 0 !important;
}


.instagram-post-layout .comment-input {
    margin-top: auto !important;
    background: white !important;
    border-top: 1px solid #eee !important;
}

.instagram-post-layout>.post {
    width: 100%;
    height: 100%;

    display: grid;
    grid-template-columns: 60% 40%;

    overflow: hidden;
}


.instagram-post-layout .post-header,
.instagram-post-layout .post-text,
.instagram-post-layout .post-stats,
.instagram-post-layout .post-actions,
.instagram-post-layout .post-image,
.instagram-post-layout .post-video-container {
    grid-column: 1;
}


.instagram-post-layout .post-image,
.instagram-post-layout .post-video-container {
    width: 100%;
    height: 100%;
    background: black;

    display: flex;
    align-items: center;
    justify-content: center;

    overflow: hidden;
}


.instagram-post-layout .post-image img,
.instagram-post-layout .post-video-container video {
    width: 100%;
    height: 100%;
    object-fit: contain;
}


.instagram-post-layout .post-stats,
.instagram-post-layout .post-actions,
.instagram-post-layout .post-text {
    padding-inline: 20px;
}


.highlighted-comment {
    position: relative;
    isolation: isolate;
    overflow: hidden;
    border: 1px solid rgba(233, 90, 19, .5) !important;
    border-radius: 14px;
    background: linear-gradient(110deg, #fff8f4, #fff, #fff3ec) !important;
    box-shadow: 0 0 0 4px rgba(233,90,19,.08), 0 14px 30px rgba(30,63,88,.14) !important;
    animation: publishedCommentFocus 1.05s cubic-bezier(.16,1,.3,1) both !important;
}

.highlighted-comment::before {
    content: "";
    position: absolute;
    z-index: -1;
    top: 0;
    bottom: 0;
    left: 0;
    width: 3px;
    background: #e95a13;
    box-shadow: 0 0 15px rgba(233,90,19,.7);
}

.highlighted-comment::after {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 22%;
    pointer-events: none;
    background: linear-gradient(90deg, transparent, rgba(233,90,19,.2), transparent);
    transform: translateX(-150%) skewX(-16deg);
    animation: publishedCommentScan 1.15s .18s ease-out both;
}

@keyframes publishedCommentFocus {
    0% { opacity: 0; filter: blur(9px); transform: perspective(700px) translateY(28px) rotateX(10deg) scale(.9); }
    48% { opacity: 1; filter: none; transform: perspective(700px) translateY(-6px) rotateX(-2deg) scale(1.035); }
    72% { transform: translateY(2px) scale(.99); }
    100% { transform: none; }
}

@keyframes publishedCommentScan {
    to { transform: translateX(600%) skewX(-16deg); opacity: 0; }
}

@media (prefers-reduced-motion: reduce) {
    .highlighted-comment,
    .highlighted-comment::after {
        animation: none !important;
    }
}


.share-success {
    position: fixed;
    inset: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    backdrop-filter: blur(10px);
    background: rgba(0, 0, 0, .25);
    z-index: 999999;

    animation: fadeIn .4s;
}

.share-success-box {

    background: white;
    padding: 30px;
    border-radius: 30px;

    display: flex;
    flex-direction: column;
    align-items: center;

    min-width: 300px;

    box-shadow:
        0 20px 60px rgba(0, 0, 0, .25);

    animation: pop .5s;
}

.success-circle {

    width: 80px;
    height: 80px;

    border-radius: 50%;

    display: flex;
    align-items: center;
    justify-content: center;

    font-size: 40px;
    font-weight: bold;

    background: linear-gradient(135deg,
            #7b61ff,
            #3b82f6,
            #00d4ff);

    color: white;

    margin-bottom: 15px;

    animation: pulse 1s infinite;
}

.share-success h3 {
    margin: 0;
    font-size: 22px;
}

.share-success p {
    opacity: .7;
    margin-top: 8px;
}

@keyframes pop {

    0% {
        transform: scale(.5);
        opacity: 0;
    }

    100% {
        transform: scale(1);
        opacity: 1;
    }

}

@keyframes pulse {

    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.08);
    }

    100% {
        transform: scale(1);
    }

}

@keyframes fadeIn {

    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }

}
`, "",{"version":3,"sources":["webpack://./src/componentsL/PostModal.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;GAcG;;;AAGH;IACI,wBAAwB;IACxB,wBAAwB;;IAExB,gBAAgB;;IAEhB,aAAa;IACb,mBAAmB;;IAEnB,iBAAiB;IACjB,mBAAmB;;IAEnB;sCACkC;;IAElC,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA,WAAW;AACX;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,2CAA2C;IAC3C;;qCAEiC;IACjC,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;IACvB,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA,SAAS;AACT;IACI,SAAS;IACT,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA,kBAAkB;AAClB;IACI,wBAAwB;IACxB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB;;;oBAGgB;IAChB;sCACkC;IAClC,cAAc;AAClB;;AAEA,UAAU;AACV;IACI,aAAa;AACjB;;AAEA,cAAc;AACd;IACI,UAAU;AACd;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA,cAAc;AACd;IACI;QACI,UAAU;QACV,sCAAsC;IAC1C;;IAEA;QACI,UAAU;QACV,iCAAiC;IACrC;AACJ;;AAEA,WAAW;AACX;IACI;QACI,YAAY;QACZ,aAAa;QACb,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,eAAe;IACnB;;IAEA;QACI,wBAAwB;QACxB,WAAW;QACX,mBAAmB;QACnB,gBAAgB;IACpB;AACJ;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI;;;oBAGgB;IAChB,0BAA0B;IAC1B,8BAA8B;AAClC;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,4BAA4B;IAChC;AACJ;;;AAGA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;;AAEpB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;;AAGA;IACI,4BAA4B;;IAE5B,sBAAsB;IACtB,uBAAuB;;IAEvB,wBAAwB;IACxB,2BAA2B;;IAE3B,2BAA2B;;IAE3B,wBAAwB;IACxB,iCAAiC;;IAEjC,0BAA0B;;IAE1B,2BAA2B;AAC/B;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;;IAE7B,qBAAqB;IACrB,uBAAuB;;IAEvB,oBAAoB;IACpB,qBAAqB;IACrB,sBAAsB;IACtB,uBAAuB;;IAEvB,0BAA0B;;IAE1B,4BAA4B;;IAE5B,wBAAwB;IACxB,iCAAiC;;IAEjC,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;;IAE3B,2BAA2B;IAC3B,0BAA0B;;IAE1B,wBAAwB;IACxB,iCAAiC;AACrC;;AAEA;IACI,oBAAkB;IAClB,2BAA2B;IAC3B,wBAAwB;AAC5B;;;AAGA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,qCAAqC;AACzC;;AAEA;IACI,WAAW;IACX,YAAY;;IAEZ,aAAa;IACb,8BAA8B;;IAE9B,gBAAgB;AACpB;;;AAGA;;;;;;IAMI,cAAc;AAClB;;;AAGA;;IAEI,WAAW;IACX,YAAY;IACZ,iBAAiB;;IAEjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB,gBAAgB;AACpB;;;AAGA;;IAEI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;;AAGA;;;IAGI,oBAAoB;AACxB;;;AAGA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,kDAAkD;IAClD,mBAAmB;IACnB,sEAAsE;IACtE,oFAAoF;IACpF,+EAA+E;AACnF;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,SAAS;IACT,OAAO;IACP,UAAU;IACV,mBAAmB;IACnB,uCAAuC;AAC3C;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,UAAU;IACV,oBAAoB;IACpB,gFAAgF;IAChF,0CAA0C;IAC1C,wDAAwD;AAC5D;;AAEA;IACI,KAAK,UAAU,EAAE,iBAAiB,EAAE,uEAAuE,EAAE;IAC7G,MAAM,UAAU,EAAE,YAAY,EAAE,0EAA0E,EAAE;IAC5G,MAAM,qCAAqC,EAAE;IAC7C,OAAO,eAAe,EAAE;AAC5B;;AAEA;IACI,KAAK,yCAAyC,EAAE,UAAU,EAAE;AAChE;;AAEA;IACI;;QAEI,0BAA0B;IAC9B;AACJ;;;AAGA;IACI,eAAe;IACf,QAAQ;IACR,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,2BAA2B;IAC3B,8BAA8B;IAC9B,eAAe;;IAEf,qBAAqB;AACzB;;AAEA;;IAEI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;;IAEnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;;IAEnB,gBAAgB;;IAEhB;sCACkC;;IAElC,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,YAAY;;IAEZ,kBAAkB;;IAElB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB,eAAe;IACf,iBAAiB;;IAEjB;;;oBAGgB;;IAEhB,YAAY;;IAEZ,mBAAmB;;IAEnB,4BAA4B;AAChC;;AAEA;IACI,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;;IAEI;QACI,oBAAoB;QACpB,UAAU;IACd;;IAEA;QACI,mBAAmB;QACnB,UAAU;IACd;;AAEJ;;AAEA;;IAEI;QACI,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,mBAAmB;IACvB;;AAEJ;;AAEA;;IAEI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;AAEJ","sourcesContent":["/* .post-modal {\n    width: min(920px, 94vw);\n    max-height: 92vh;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    background: rgba(255, 255, 255, .96);\n    backdrop-filter: blur(18px);\n    border-radius: 28px;\n    box-shadow:\n        0 30px 80px rgba(0, 0, 0, .22),\n        inset 0 1px 0 rgba(255, 255, 255, .7);\n    animation: postModalIn .28s ease;\n    position: relative;\n} */\n\n\n.post-modal {\n    width: min(1400px, 96vw);\n    height: min(90vh, 950px);\n\n    overflow: hidden;\n\n    display: flex;\n    flex-direction: row;\n\n    background: white;\n    border-radius: 28px;\n\n    box-shadow:\n        0 30px 80px rgba(0, 0, 0, .22);\n\n    animation: postModalIn .28s ease;\n    position: relative;\n}\n\n/* header */\n.post-modal-header {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    padding: 22px 24px;\n    border-bottom: 1px solid rgba(0, 0, 0, .06);\n    background: linear-gradient(to bottom,\n            rgba(255, 255, 255, .92),\n            rgba(255, 255, 255, .75));\n    backdrop-filter: blur(14px);\n}\n\n.post-modal-header img {\n    width: 52px;\n    height: 52px;\n    border-radius: 50%;\n    object-fit: cover;\n    border: 3px solid white;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, .12);\n}\n\n.post-modal-header strong {\n    font-size: 17px;\n    font-weight: 800;\n    color: #111827;\n    letter-spacing: -.2px;\n}\n\n/* text */\n.post-modal-text {\n    margin: 0;\n    padding: 22px 24px 8px;\n    font-size: 15px;\n    line-height: 1.7;\n    color: #1f2937;\n    white-space: pre-wrap;\n    word-break: break-word;\n}\n\n/* media wrapper */\n.post-modal-media {\n    width: calc(100% - 32px);\n    margin: 16px;\n    max-height: 68vh;\n    object-fit: contain;\n    border-radius: 24px;\n    background:\n        linear-gradient(135deg,\n            #0f172a,\n            #111827);\n    box-shadow:\n        0 18px 50px rgba(0, 0, 0, .18);\n    display: block;\n}\n\n/* video */\nvideo.post-modal-media {\n    outline: none;\n}\n\n/* scrollbar */\n.post-modal::-webkit-scrollbar {\n    width: 8px;\n}\n\n.post-modal::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, .15);\n    border-radius: 50px;\n}\n\n/* animation */\n@keyframes postModalIn {\n    from {\n        opacity: 0;\n        transform: translateY(24px) scale(.96);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0) scale(1);\n    }\n}\n\n/* mobile */\n@media (max-width: 768px) {\n    .post-modal {\n        width: 100vw;\n        height: 100vh;\n        max-height: 100vh;\n        border-radius: 0;\n    }\n\n    .post-modal-header {\n        padding: 18px;\n    }\n\n    .post-modal-text {\n        padding: 18px 18px 6px;\n        font-size: 14px;\n    }\n\n    .post-modal-media {\n        width: calc(100% - 18px);\n        margin: 9px;\n        border-radius: 18px;\n        max-height: 56vh;\n    }\n}\n\n\n.post-modal-close {\n    width: 42px;\n    height: 42px;\n    border: none;\n    border-radius: 50%;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #f3f5f8;\n    color: #111;\n    flex-shrink: 0;\n    transition: .2s;\n}\n\n.post-modal-close:hover {\n    transform: scale(1.05);\n    background: #e9edf4;\n}\n\n.post-modal-close.mobile {\n    display: none;\n}\n\n.post-modal-close.desktop {\n    margin-left: auto;\n}\n\n@media (max-width:768px) {\n    .post-modal-close.mobile {\n        display: flex;\n    }\n\n    .post-modal-close.desktop {\n        display: none;\n    }\n}\n\n\n.post-modal-skeleton {\n    padding: 24px;\n}\n\n.pm-sk-header {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    margin-bottom: 24px;\n}\n\n.pm-sk-avatar {\n    width: 52px;\n    height: 52px;\n    border-radius: 50%;\n}\n\n.pm-sk-name {\n    width: 140px;\n    height: 18px;\n    border-radius: 20px;\n}\n\n.pm-sk-text {\n    width: 100%;\n    height: 14px;\n    border-radius: 20px;\n    margin-bottom: 12px;\n}\n\n.pm-sk-text.short {\n    width: 55%;\n}\n\n.pm-sk-media {\n    width: 100%;\n    height: 420px;\n    border-radius: 24px;\n    margin-top: 20px;\n}\n\n.skeleton {\n    background: linear-gradient(90deg,\n            #ececec,\n            #f7f7f7,\n            #ececec);\n    background-size: 200% 100%;\n    animation: pulse 1.2s infinite;\n}\n\n@keyframes pulse {\n    0% {\n        background-position: 200% 0;\n    }\n\n    100% {\n        background-position: -200% 0;\n    }\n}\n\n\n.instagram-post-layout {\n    display: flex;\n    width: 100%;\n    height: 100%;\n    background: white;\n    border-radius: 24px;\n    overflow: hidden;\n\n}\n\n.instagram-left {\n    width: 60%;\n    background: black;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.instagram-main-media {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}\n\n.instagram-right {\n    width: 40%;\n    display: flex;\n    flex-direction: column;\n    border-left: 1px solid #eee;\n    background: white;\n}\n\n.instagram-post-header {\n    height: 72px;\n    padding: 20px;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    border-bottom: 1px solid #eee;\n}\n\n.instagram-post-header img {\n    width: 42px;\n    height: 42px;\n    border-radius: 50%;\n    object-fit: cover;\n}\n\n\n.instagram-right .comment-panel {\n    background: white !important;\n\n    width: 100% !important;\n    height: 100% !important;\n\n    min-height: 0 !important;\n    max-height: none !important;\n\n    border-radius: 0 !important;\n\n    display: flex !important;\n    flex-direction: column !important;\n\n    animation: none !important;\n\n    overflow: hidden !important;\n}\n\n.instagram-right .comment-list {\n    flex: 1;\n    overflow-y: auto;\n    min-height: 0;\n}\n\n.instagram-right .comment-input {\n    margin-top: auto;\n    border-top: 1px solid #eee;\n    background: white;\n}\n\n.instagram-post-layout .comment-overlay {\n    position: relative !important;\n\n    width: 40% !important;\n    height: 100% !important;\n\n    top: auto !important;\n    left: auto !important;\n    right: auto !important;\n    bottom: auto !important;\n\n    transform: none !important;\n\n    background: white !important;\n\n    display: flex !important;\n    flex-direction: column !important;\n\n    overflow: hidden !important;\n}\n\n.instagram-post-layout .comment-panel {\n    width: 100% !important;\n    height: 100% !important;\n    max-height: none !important;\n\n    border-radius: 0 !important;\n    animation: none !important;\n\n    display: flex !important;\n    flex-direction: column !important;\n}\n\n.instagram-post-layout .comment-list {\n    flex: 1 !important;\n    overflow-y: auto !important;\n    min-height: 0 !important;\n}\n\n\n.instagram-post-layout .comment-input {\n    margin-top: auto !important;\n    background: white !important;\n    border-top: 1px solid #eee !important;\n}\n\n.instagram-post-layout>.post {\n    width: 100%;\n    height: 100%;\n\n    display: grid;\n    grid-template-columns: 60% 40%;\n\n    overflow: hidden;\n}\n\n\n.instagram-post-layout .post-header,\n.instagram-post-layout .post-text,\n.instagram-post-layout .post-stats,\n.instagram-post-layout .post-actions,\n.instagram-post-layout .post-image,\n.instagram-post-layout .post-video-container {\n    grid-column: 1;\n}\n\n\n.instagram-post-layout .post-image,\n.instagram-post-layout .post-video-container {\n    width: 100%;\n    height: 100%;\n    background: black;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    overflow: hidden;\n}\n\n\n.instagram-post-layout .post-image img,\n.instagram-post-layout .post-video-container video {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}\n\n\n.instagram-post-layout .post-stats,\n.instagram-post-layout .post-actions,\n.instagram-post-layout .post-text {\n    padding-inline: 20px;\n}\n\n\n.highlighted-comment {\n    position: relative;\n    isolation: isolate;\n    overflow: hidden;\n    border: 1px solid rgba(233, 90, 19, .5) !important;\n    border-radius: 14px;\n    background: linear-gradient(110deg, #fff8f4, #fff, #fff3ec) !important;\n    box-shadow: 0 0 0 4px rgba(233,90,19,.08), 0 14px 30px rgba(30,63,88,.14) !important;\n    animation: publishedCommentFocus 1.05s cubic-bezier(.16,1,.3,1) both !important;\n}\n\n.highlighted-comment::before {\n    content: \"\";\n    position: absolute;\n    z-index: -1;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 3px;\n    background: #e95a13;\n    box-shadow: 0 0 15px rgba(233,90,19,.7);\n}\n\n.highlighted-comment::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 22%;\n    pointer-events: none;\n    background: linear-gradient(90deg, transparent, rgba(233,90,19,.2), transparent);\n    transform: translateX(-150%) skewX(-16deg);\n    animation: publishedCommentScan 1.15s .18s ease-out both;\n}\n\n@keyframes publishedCommentFocus {\n    0% { opacity: 0; filter: blur(9px); transform: perspective(700px) translateY(28px) rotateX(10deg) scale(.9); }\n    48% { opacity: 1; filter: none; transform: perspective(700px) translateY(-6px) rotateX(-2deg) scale(1.035); }\n    72% { transform: translateY(2px) scale(.99); }\n    100% { transform: none; }\n}\n\n@keyframes publishedCommentScan {\n    to { transform: translateX(600%) skewX(-16deg); opacity: 0; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .highlighted-comment,\n    .highlighted-comment::after {\n        animation: none !important;\n    }\n}\n\n\n.share-success {\n    position: fixed;\n    inset: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    backdrop-filter: blur(10px);\n    background: rgba(0, 0, 0, .25);\n    z-index: 999999;\n\n    animation: fadeIn .4s;\n}\n\n.share-success-box {\n\n    background: white;\n    padding: 30px;\n    border-radius: 30px;\n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    min-width: 300px;\n\n    box-shadow:\n        0 20px 60px rgba(0, 0, 0, .25);\n\n    animation: pop .5s;\n}\n\n.success-circle {\n\n    width: 80px;\n    height: 80px;\n\n    border-radius: 50%;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    font-size: 40px;\n    font-weight: bold;\n\n    background: linear-gradient(135deg,\n            #7b61ff,\n            #3b82f6,\n            #00d4ff);\n\n    color: white;\n\n    margin-bottom: 15px;\n\n    animation: pulse 1s infinite;\n}\n\n.share-success h3 {\n    margin: 0;\n    font-size: 22px;\n}\n\n.share-success p {\n    opacity: .7;\n    margin-top: 8px;\n}\n\n@keyframes pop {\n\n    0% {\n        transform: scale(.5);\n        opacity: 0;\n    }\n\n    100% {\n        transform: scale(1);\n        opacity: 1;\n    }\n\n}\n\n@keyframes pulse {\n\n    0% {\n        transform: scale(1);\n    }\n\n    50% {\n        transform: scale(1.08);\n    }\n\n    100% {\n        transform: scale(1);\n    }\n\n}\n\n@keyframes fadeIn {\n\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
